import React, { useState, useEffect } from "react";
import "tailwindcss/tailwind.css";
import CarouselButtons from "./components/CarouselButtons"; // Assuming CarouselButtons component is in the same directory
import ParallelButtons from "./components/ParallelButtons";

const images = [
  "/img/01卵石灰.png",
  "/img/02米可白.png",
  "/img/03磨石子灰.png",
  "/img/04島灰.png",
  "/img/05杏仁島灰.png",
  "/img/06電線桿灰.png",
  "/img/07水管灰.png",
  "/img/08晨間報紙.png",
  "/img/09海豚灰.png",
  "/img/10水泥灰.png",
  "/img/11提拉米蘇.png",
  "/img/12柏油路灰.png",
  "/img/13排水蓋灰.png",
  "/img/14雪茄棕.png",
  "/img/15巧克力.png",
  "/img/16生鏽棕.png",
  "/img/17消防栓紅.png",
  "/img/18擲筊紅.png",
  "/img/19廟簷橘.png",
  "/img/20辦桌紅.png",
  "/img/21三角錐橘.png",
  "/img/22藕粉色.png",
  "/img/23蜜桃莓果.png",
  "/img/24櫻花粉.png",
  "/img/25奶油粉.png",
  "/img/26磚杏色.png",
  "/img/27醃蘿蔔黃.png",
  "/img/28垃圾車黃.png",
  "/img/29黃芥末.png",
  "/img/30米黃.png",
  "/img/31米綠.png",
  "/img/32變電箱綠.png",
  "/img/33鐵皮綠.png",
  "/img/34抹茶紅豆.png",
  "/img/35苔蘚綠.png",
  "/img/36鐵飯盒灰.png",
  "/img/37蕉綠.png",
  "/img/38抹茶綠.png",
  "/img/39藏青色.png",
  "/img/40郵筒綠.png",
  "/img/41路牌綠.png",
  "/img/42森林綠.png",
  "/img/43蘇打綠.png",
  "/img/44湖水藍.png",
  "/img/45舊衣回收箱.png",
  "/img/46帆布藍.png",
  "/img/47天空藍.png",
  "/img/48鐵門藍.png",
  "/img/49蔚藍.png",
  "/img/50鳩北藍.png",
  "/img/51冰水藍.png",
  "/img/52渣藍.png",
  "/img/53藍瘦香菇.png",
  "/img/54暮色藍.png",
  "/img/55貨車藍.png",
  "/img/56宇宙星空.png",
];

const images_res = [
  "/img/iPhone01卵石灰.png",
  "/img/iPhone02米可白.png",
  "/img/iPhone03磨石子灰.png",
  "/img/iPhone04島灰.png",
  "/img/iPhone05杏仁島灰.png",
  "/img/iPhone06電線桿灰.png",
  "/img/iPhone07水管灰.png",
  "/img/iPhone08晨間報紙.png",
  "/img/iPhone09海豚灰.png",
  "/img/iPhone10水泥灰.png",
  "/img/iPhone11提拉米蘇.png",
  "/img/iPhone12柏油路灰.png",
  "/img/iPhone13排水蓋灰.png",
  "/img/iPhone14雪茄棕.png",
  "/img/iPhone15巧克力.png",
  "/img/iPhone16生鏽棕.png",
  "/img/iPhone17消防栓紅.png",
  "/img/iPhone18擲筊紅.png",
  "/img/iPhone19廟簷橘.png",
  "/img/iPhone20辦桌紅.png",
  "/img/iPhone21三角錐橘.png",
  "/img/iPhone22藕粉色.png",
  "/img/iPhone23蜜桃莓果.png",
  "/img/iPhone24櫻花粉.png",
  "/img/iPhone25奶油粉.png",
  "/img/iPhone26磚杏色.png",
  "/img/iPhone27醃蘿蔔黃.png",
  "/img/iPhone28垃圾車黃.png",
  "/img/iPhone29黃芥末.png",
  "/img/iPhone30米黃.png",
  "/img/iPhone31米綠.png",
  "/img/iPhone32變電箱綠.png",
  "/img/iPhone33鐵皮綠.png",
  "/img/iPhone34抹茶紅豆.png",
  "/img/iPhone35苔蘚綠.png",
  "/img/iPhone36鐵飯盒灰.png",
  "/img/iPhone37蕉綠.png",
  "/img/iPhone38抹茶綠.png",
  "/img/iPhone39藏青色.png",
  "/img/iPhone40郵筒綠.png",
  "/img/iPhone41路牌綠.png",
  "/img/iPhone42森林綠.png",
  "/img/iPhone43蘇打綠.png",
  "/img/iPhone44湖水藍.png",
  "/img/iPhone45舊衣回收箱.png",
  "/img/iPhone46帆布藍.png",
  "/img/iPhone47天空藍.png",
  "/img/iPhone48鐵門藍.png",
  "/img/iPhone49蔚藍.png",
  "/img/iPhone50鳩北藍.png",
  "/img/iPhone51冰水藍.png",
  "/img/iPhone52渣藍.png",
  "/img/iPhone53藍瘦香菇.png",
  "/img/iPhone54暮色藍.png",
  "/img/iPhone55貨車藍.png",
  "/img/iPhone56宇宙星空.png",
];

const colors = [
  'bg-[#D7D5D3]', 'bg-[#D5D4CA]', 'bg-[#C3C8C9]', 'bg-[#BCBCBA]', 'bg-[#B0B3AC]', 'bg-[#B6B7BF]', 'bg-[#A1A19F]', 'bg-[#9E9595]', 'bg-[#8A8A8A]', 'bg-[#767982]', 
  'bg-[#7D756A]', 'bg-[#545453]', 'bg-[#413F3D]', 'bg-[#4F4535]', 'bg-[#574231]', 'bg-[#6B4036]', 'bg-[#871D20]', 'bg-[#96382B]', 'bg-[#BD3C26]', 'bg-[#DF1933]', 
  'bg-[#E45C44]', 'bg-[#AF7471]', 'bg-[#E4AEBB]', 'bg-[#F0DFE2]', 'bg-[#F4E0D2]', 'bg-[#D1B898]', 'bg-[#F4C45D]', 'bg-[#E8A93D]', 'bg-[#D0C594]', 'bg-[#C9C2AC]', 
  'bg-[#EFF0E5]', 'bg-[#BEC8AF]', 'bg-[#B1B187]', 'bg-[#BABBA7]', 'bg-[#A1A191]', 'bg-[#9AA2A2]', 'bg-[#A8B8B5]', 'bg-[#819B8E]', 'bg-[#5B6D6C]', 'bg-[#41694E]', 
  'bg-[#578473]', 'bg-[#5E7F87]', 'bg-[#52B8C9]', 'bg-[#8CC9DA]', 'bg-[#A8CDE5]', 'bg-[#91BCE1]', 'bg-[#76A4C7]', 'bg-[#6989A7]', 'bg-[#6B85B7]', 'bg-[#84A6B4]', 
  'bg-[#92ADB1]', 'bg-[#7E9799]', 'bg-[#50738E]', 'bg-[#3F5B7C]', 'bg-[#1F6789]', 'bg-[#123277]'
];
const App = () => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [dragStart, setDragStart] = useState(null);
  const [fadeOut, setFadeOut] = useState(false);
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleDragStart = (e) => {
    setDragStart(e.clientX);
  };

  const handleButtonClick = (index) => {
    setFadeOut(true); // Start the fade-out animation
    setTimeout(() => {
      setSelectedImageIndex(index);
      setFadeIn(true); // Start the fade-in animation
      setFadeOut(false); // Reset the fade-out animation
    }, 500); // Adjust the delay to match the CSS transition duration
  };

  const handleDragEnd = (e) => {
    const dragEnd = e.clientX;
    const threshold = 50; // adjust as needed
    if (dragStart && dragEnd - dragStart > threshold) {
      // Dragged right
      handleNext();
    } else if (dragStart && dragStart - dragEnd > threshold) {
      // Dragged left
      handlePrevious();
    }
    setDragStart(null);
  };

  const handlePrevious = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const getBackgroundImage = () => {
    if (windowWidth < 767) {
      return `url(${images_res[selectedImageIndex]})`;
    } else {
      return `url(${images[selectedImageIndex]})`;
    }
  };

  const getImage = () => {
    if (windowWidth < 767) {
      return `url(${images_res[selectedImageIndex]})`;
    } else {
      return `url(${images[selectedImageIndex]})`;
    }
  };

  return (
    <div
      className={`flex flex-col h-screen items-center back justify-between inset-0 transition-opacity bg-center bg-cover ${
        fadeOut ? "opacity-30" : "opacity-100"
      } ${colors[selectedImageIndex]}`}
      onMouseDown={handleDragStart}
      onMouseUp={handleDragEnd}
      style={{
        // backgroundSize: '100% 100%',
        backgroundImage: getBackgroundImage(),
      }}
    >
      {/* <nav className="w-full absolute">
        <div className={`sm:justify-between justify-center sm:py-6 pt-20 px-9 flex w-full py-10`}>
          <div className="">
            <img src="/image/Group_1_a.png" className="sm:w-[130px] w-[100px]"/>
          </div>
          <div className="sm:flex hidden"></div>
        </div>
      </nav> */}
      <div></div>
      {/* <div className="flex flex-col justify-center items-center">
        <img src={images[selectedImageIndex]} className="sm:w-3/4 w-1/1" />
      </div> */}
      <div
        className={`flex flex-col items-center justify-between inset-0 transition-opacity ${
          fadeOut ? "opacity-30" : "opacity-100"
        }`}
        // style={{
        //   backgroundSize: "100% 100%",
        //   backgroundImage: getBackgroundImage(),
        // }}
      >
        {/* {windowWidth > 767 ? (
            <CarouselButtons
              selectedImageIndex={selectedImageIndex}
              totalImages={images.length}
              onClick={handleButtonClick} 
              source={images}
              count={10}
            />
          ) : ( */}
        <ParallelButtons
          selectedImageIndex={selectedImageIndex}
          totalImages={images.length}
          onClick={handleButtonClick}
          source={images}
          count={windowWidth > 1350 ? 12 : 6}
        />
        {/* )} */}
      </div>
      {/* <div
        className={`flex flex-col items-center justify-between flex-1 inset-0 transition-opacity ${
          fadeOut ? "opacity-30" : "opacity-100"
        }`}
        style={{
          backgroundSize: "100% 100%",
          backgroundImage: getBackgroundImage(),
        }}
      >
        <div></div>
        {windowWidth > 767 ? (
          <CarouselButtons
            selectedImageIndex={selectedImageIndex}
            totalImages={images.length}
            onClick={handleButtonClick}
            source={images}
            count={10}
          />
        ) : (
          <ParallelButtons
            selectedImageIndex={selectedImageIndex}
            totalImages={images.length}
            onClick={handleButtonClick}
            source={images}
            count={6}
          />
        )}
      </div> */}
    </div>
  );
};

export default App;
